import { Inject, Injectable } from "@angular/core";
import { APP_TYPE, AppType } from "../app.type";

@Injectable({
  providedIn: "root",
})
export class DatesFilterService implements DatesFilterService {
  showComponent = false;
  /** The date column whose picker is open, so the picked date lands on that column. */
  field: string | null = null;
  model = {
    dateMode: "specific",
    specificDate: null,
    fromDate: null,
    toDate: null,
  };

  constructor(@Inject(APP_TYPE) private app: AppType) {}

  // A date column carries its own interval under "<column>From" / "<column>To". The search API
  // reads the same convention, so every date column can be filtered independently.
  getColumnRangeFields(field: string | null): {
    specific: string;
    from: string;
    to: string;
  } {
    const specific = field ?? "";

    return { specific, from: `${specific}From`, to: `${specific}To` };
  }

  // The specific/from/to filterByPage keys backing a date-range filter. The
  // selected field is the "specific" key; validationDate has its own from/to
  // helpers, everything else (update_time) uses the shared from/to.
  getRangeFields(field: string | null): {
    specific: string;
    from: string;
    to: string;
  } {
    const specific = field ?? "";
    if (specific === this.app.fieldId.thread.validationDate) {
      return {
        specific,
        from: this.app.fieldId.thread.validationDateFrom,
        to: this.app.fieldId.thread.validationDateTo,
      };
    }
    return {
      specific,
      from: this.app.fieldId.thread.from,
      to: this.app.fieldId.thread.to,
    };
  }

  clear() {
    this.app.datesFilter.model = {
      dateMode: "specific",
      specificDate: null,
      fromDate: null,
      toDate: null,
    };
  }
}
